<template>
  <div class="pur-card hit-cursor" @click="handleClick">
    <div class="card-top">
      <div class="card-title">
        <el-tag size="mini" v-if="data.type === 1" type="success" effect="dark">
          买技术
        </el-tag>
        <el-tag size="mini" v-else effect="dark"> 卖技术 </el-tag>
        <div class="card-title-name ellipsis-one-line">{{ data.title }}</div>
        <div class="card-title-price">￥{{ data.price == 0 ? '面议' : data.price }}</div>
      </div>
      <div class="card-desc">CAS: {{ data.cas_no }}</div>
      <div class="card-info" v-if="data.address">{{ data.address.province + data.address.city + data.address.area }}
      </div>
      <div class="card-info">
        <span>{{ data.upto_at }}</span>
        <span class="card-info-look">{{ data.view_count }}人次浏览</span>
      </div>
    </div>
    <div class="card-bottom ">
      <div class="card-bottom-tag">
        <el-tag size="mini" type="info">
          {{ data.tech_type == 1 ? '专利' : '非专利' }}
        </el-tag>
        <el-tag size="mini" type="info">
          {{ data.co_type }}
        </el-tag>
        <el-tag size="mini" type="info">
          {{ data.tech_maturity }}
        </el-tag>
      </div>
      <i class="el-icon-more"></i>
    </div>
  </div>
</template>
<script>
export default {
  name: "pur-card",
  props: {
    data: {
      type: Object,
      default: () => { },
    },
  },
  computed: {
    isLogin() {
      return this.$store.state.user.isLogin;
    },
  },
  methods: {
    handleClick() {
      if (!this.isLogin) {
        this.$confirm("请先登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push("/login");
        });
        return;
      }
      this.$router.push({
        path: '/technology/detail',
        query: { id: this.data.id }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.pur-card {
  width: 330px;
  height: 190px;
  background: #ffffff;
  border-radius: 6px 6px 6px 6px;
  border: 1px solid #e7eaf3;
  box-sizing: border-box;
  padding: 19px 15px;

  .card-top {
    border-bottom: 1px solid #e7eaf3;

    .card-title {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .card-title-name {
        font-weight: bold;
        font-size:var(--font-size-default-16);
        color: #525666;
        margin: 0 12px 0 8px;
      }

      .ellipsis-one-line {
        width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .card-title-price {
        font-weight: bold;
        font-size: var(--font-size-default-16);;
        color: #ea4335;
      }

    }

    .card-desc {
      font-weight: 400;
      font-size: var(--font-size-default-14);
      color: #7a8199;
      margin: 15px 0;
    }

    .card-info {
      font-size: var(--font-size-default-14);
      color: #7A8199;
      margin-block: 10px;
      display: flex;

      .card-info-look {
        margin-left: 27px;
      }
    }
  }

  .card-bottom {
    color: #7A8199;
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    align-items: center;

    .card-bottom-tag {
      display: flex;
      gap: 12px;
    }
  }
}
</style>